import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";
import path from "path";

const PaymentDetailsList = Loadable(
  lazy(() =>
    import("./paymentDetailsList").then(({ PaymentDetailsList }) => ({
      default: PaymentDetailsList,
    }))
  )
);
const PaymentDashboard = Loadable(
  lazy(() =>
    import("./paymentDashboard").then(({ PaymentDashboard }) => ({
      default: PaymentDashboard,
    }))
  )
);

export const paymentDetailsRoutes = [
  {
    path: "/payment/payment-details",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.PAYMENT_TRANSACTION]}>
        <PaymentDetailsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/payment/dashboard",
    exact: true,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.PAYMENT_DETAILS_GROUP_BY_LEADS]}
      >
        <PaymentDashboard />
      </AuthorizedRoute>
    ),
  },
];
